// Made-to-order ship line (prompt 117; prompt 130 back to the range). Every [data-ssc-ship-by] reads "ships in 3–5 weeks"
// (also the Liquid text, so nothing changes without JS). SHOW_DATE = true brings back the exact date: today + 35 days in
// the shopper's browser, "ships by Nov 27". Used by the product page, the quick add (assets/ssc-product.js) and the
// bundler (assets/ssc-bundler.js).
(function () {
  var SHOW_DATE = false;
  function date() {
    var d = new Date();
    d.setDate(d.getDate() + 35);
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  }
  function fill(scope) {
    var text = SHOW_DATE ? 'ships by ' + date() : 'ships in 3–5 weeks';
    (scope || document).querySelectorAll('[data-ssc-ship-by]').forEach(function (node) {
      if (node.textContent !== text) node.textContent = text;
    });
  }
  window.SSCShipBy = { date: date, fill: fill, showDate: SHOW_DATE };
  fill(document);
})();
